/**
 * Сегменты подвкладок этапа: `/championships/:id/steps/:stageId/<tab>`.
 *
 * Живут в `domain`, а не рядом с формой, по той же причине, что и
 * `ChampionshipEditTab`: слаг — часть роута, а не деталь вёрстки.
 *
 * Подвкладки «Редактирование» здесь нет намеренно — это корень этапа
 * (`/steps/:stageId`), своего сегмента у неё нет. Поэтому у билдера
 * `Pages.CHAMPIONSHIPS.STEPS.builders.stage` вкладка необязательна.
 */
export enum ChampionshipStageTab {
  TEAMS = 'teams',
  GRID = 'grid',
  MATCHES = 'matches',
}
